import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll('.icon--logo-badge.will-change-transform').forEach((el) => {
  ScrollTrigger.create({
    trigger: el,
    scrub: 0.1,
    onUpdate: (self) => {
      gsap.to(self.trigger, { rotation: self.progress * 90, duration: 1, ease: 'none' });
    },
  });
});
